"use strict";

class StationSettingsBearersOverviewCtrl {
    constructor($rootScope, $http, $mdToast, $mdDialog, $scope, $state) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;
        this.$state = $state;
        this.status = {saving: false, errors: false};
        this.fields = [{'invalid_pi': false}];
        this.forms = [];

        this.fetch();

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = this.save.bind(this);
    }

    fetch() {
        this.fields = [];
        this.$http.get('/bearers').then(response => {
            this.fields = response.data;
            this.spliceUrl();
        });
        
        return this.$http.get('/country').then((result) => {
            if (typeof result.data[0] != 'undefined') {
                this.country_data = result.data[0];
            }
        });
    }



    spliceUrl() {
        for (let field in this.fields) {
            if (this.fields[field].url) {
                this.fields[field].urlString = this.fields[field].url.split("/");
                this.fields[field].urlString.splice(0, 3);
                this.fields[field].urlString = this.fields[field].urlString.join("/");
            }
        }
    }

    save() {

        //console.log(this.fields);
        this.fields.map((field) => {
            field['tp'] = Number(field['tp']);
        });

        this.$http.post('/bearers', this.fields).then(() => {
            this.fetch();
            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.object_saved?object=Bearer',
                hideDelay: 6000,
                position: ('top right')
            });
            return true;
        });
    }

    addField() {
        let index = this.fields.push({
            type: {name: 'FM'},
            tp: 0
        });

        this.openBearer(index - 1);
    }


    checkActivefield(index) {
        return this.$state.params.fieldId == index;
    }


    openBearer(index) {
        this.$state.go('stationsettings.stationInformation.bearers.field', {fieldId: index});
    }


    destroyField(field, ev, index) {
        this.$mdDialog.show({
            controller: 'ConfirmDialogCtrl',
            templateUrl: "confirmDialog.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            //targetEvent: ev,
            clickOutsideToClose: true
        }).then(() => {
            if (field.id) {
                this.$http.delete('/bearers/' + field.id);
            }

            this.fields.splice(index, 1);
            this.$state.go('stationsettings.stationInformation.bearers');
        });
    }
}


StationSettingsBearersOverviewCtrl.$inject = [
    '$rootScope',
    '$http',
    '$mdToast',
    '$mdDialog',
    '$scope',
    '$state'
];

module.exports = StationSettingsBearersOverviewCtrl;